import { render, staticRenderFns } from "./PossessionStats.vue?vue&type=template&id=461540d0&"
import script from "./PossessionStats.vue?vue&type=script&lang=js&"
export * from "./PossessionStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports